import React, { Component } from 'react'
import { node } from 'prop-types'
import Panel from 'react-bootstrap/lib/Panel'
import SearchIcon from 'react-icons/lib/md/search'

import SearchStudent from 'containers/Students/search-student'

class Ledger extends Component {

  constructor(props) {
    super(props)
    this.state = {
      openSearch: false,
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.params.studentID !== this.props.params.studentID) {
      this.setState({
        openSearch: false,
      })
    }
  }

  _openSearch = () => {
    this.setState({
      openSearch: true,
    })
  }

  _closeSearch = () => {
    this.setState({
      openSearch: false,
    })
  }

  render() {
    const { openSearch } = this.state
    const { children } = this.props

    const header = (
      <div className="row">
        <div className="col-sm-6">Student Ledger</div>
        <div className="col-xs-6 text-right">
          <button type="button" onClick={this._openSearch} className="btn-icon btn-inline"><SearchIcon /></button>
        </div>
      </div>
    )

    return (
      <Panel header={header}>
        { React.cloneElement(children, { onSearchForm: this._openSearch }) }
        <SearchStudent
          linkBase="/ledger"
          handleClose={this._closeSearch}
          isOpen={openSearch}
        />
      </Panel>
    )
  }
}

Ledger.propTypes = {
  children: node,
}

export default Ledger



// WEBPACK FOOTER //
// ./src/containers/Ledger/index.js